export enum TooltipMenuBlockType {
  Media = 'media',
  Divder = 'divider',
  Callout = 'callout',
  FlashCard = 'flash_card',
}
